$(function () {
  let js_steps_animation_stopped = false;
  $('.header__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 4000,
  });

  //последовательное присвоение класса

  $('.js-steps')
    .each(function () {
      var $s = $('.js-steps-item', $(this)),
        i = 0;
      setInterval(function () {
        if (js_steps_animation_stopped) {
          i = 0;
          return;
        }
        $s.removeClass('active').eq(i).addClass('active');
        i++;
        if (i >= $s.length) i = 0;
      }, 1800);
    });


  $(".js-steps-item").hover(function () {
    $('.js-steps .js-steps-item').removeClass("active");
    js_steps_animation_stopped = true;
    $(this).addClass("no-animation").siblings().addClass("no-animation");
  }, function () {
    js_steps_animation_stopped = false;
    $(this).removeClass("no-animation").siblings().removeClass("no-animation");
  });


  //popup

  const $modal = $('#modal');
  $('[data-role="popup-show"]')
    .on('click', function () {
      const $t = $(this),
        target = $t.data('target'),
        $target = $('#' + target);
      if ($target.length) {
        $target.show();
        $('html,body').css('overflow', 'auto');
        $('#modal').fadeIn(300);
      }
      return false;
    });

  $modal
    .on('click', function (e) {
      if (e.target === $modal.get(0)) {
        $modal.fadeOut(300, function () {
          $('.popup', $modal).hide();
          $('html,body').css('overflow', 'auto');
        });
      }
    })
    .on('click', '[data-role="popup-hide"]', function () {
      $modal.fadeOut(300, function () {
        $('html,body').css('overflow', 'auto');
      });
      return false;
    })
    .on('click', '#popup', function (e) {
      e.stopPropagation();
    })
    .on('click', function () {
      $('[data-role="popup-hide"]').trigger('click');
    });

  let randomSlideId = Math.round(Math.random() * 4);
  console.log("ok2", randomSlideId);
  const $lhSlider = $('#life-hacks-slider'),
    $tSlider = $('#tours-slider'),
    $tMenu = $('#tours-slider-menu');
  if ($lhSlider.length) {
    $lhSlider.slick({
      fade: true,
      dots: true,
      prevArrow: '<div class="slider__btn-prev"></div>',
      nextArrow: '<div class="slider__btn-next"></div>'
    });
  }
  if ($tSlider.length) {
    const $btn = $('a', $tMenu);
    $btn.eq(randomSlideId).addClass('active');
    $tSlider.slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      initialSlide: randomSlideId,
      prevArrow: '<div class="slider__btn-prev"></div>',
      nextArrow: '<div class="slider__btn-next"></div>'
    })
      .on('beforeChange', function (e, s, c, n) {
        $btn.removeClass('active').eq(n).addClass('active');
      });
    // $tMenu.on('click', 'a', function () {
    //   const i = $btn.index($(this)) || 0;
    //   $tSlider.slick('slickGoTo', i);
    //
    //   return false;
    // })
  }
  console.log('Document ready');

  let
    spo = [

      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_01.png",
        "title": "Туроператор «АэроТур»",
        "name": "8 Марта в Узбекистане: «Сердце Средней Азии»",
        "duration": "6 дней / 5 ночей",
        "price": "от 47 926 рублей",
        "url": "/tours?tour=0#tour1"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_01.png",
        "title": "Туроператор «АэроТур»",
        "name": "Празднование Навруза в Узбекистане",
        "duration": "6 дней / 5 ночей",
        "price": "от 48 666 рублей",
        "url": "/tours?tour=1#tour1"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_02.png",
        "title": "Туроператор «Де Визу»",
        "name": "Аральское море и оазис древних городов",
        "duration": "10 дней / 9 ночей",
        "price": "от 66 631 рубля",
        "url": "/tours?tour=0#tour2"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_02.png",
        "title": "Туроператор «Де Визу»",
        "name": "Восточный Дастархан",
        "duration": "8 дней / 7 ночей",
        "price": "от 53 107 рублей",
        "url": "/tours?tour=1#tour2"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_03.png",
        "title": "Туроператор «Жарков-тур»",
        "name": "Тур на 8 Марта — «История Узбекистана»",
        "duration": "5 дней / 4 ночи",
        "price": "от 28 900 рублей",
        "url": "/tours?tour=0#tour3"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_03.png",
        "title": "Туроператор «Жарков-тур»",
        "name": "Тур в Узбекистан на Навруз",
        "duration": "6 дней / 5 ночей",
        "price": "от 37 100 рублей",
        "url": "/tours?tour=1#tour3"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_04.png",
        "title": "Туроператор «Карлсон туризм»",
        "name": "8 Марта в Узбекистане",
        "duration": "3 дня / 2 ночи",
        "price": "от 20 720 рублей",
        "url": "/tours?tour=0#tour4"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_04.png",
        "title": "Туроператор «Карлсон туризм»",
        "name": "Майские праздники в Узбекистане",
        "duration": "5 дней / 4 ночи",
        "price": "от 30 396 рублей",
        "url": "/tours?tour=1#tour4"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_05.png",
        "title": "Туроператор «Дельфин»",
        "name": "8 Марта в Узбекистане",
        "duration": "3 дня / 2 ночи",
        "price": "от 26 021 рубля",
        "url": "/tours?tour=0#tour5"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_05.png",
        "title": "Туроператор «Дельфин»",
        "name": "Майские праздники в Узбекистане",
        "duration": "5 дней / 4 ночи",
        "price": "от 37 702 рублей",
        "url": "/tours?tour=1#tour5"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_06.jpg",
        "title": "Туроператор «Квинта тур»",
        "name": "Вкусное путешествие в Узбекистан",
        "duration": "10 дней / 9 ночей",
        "price": "от 63 700 рублей",
        "url": "/tours?tour=0#tour6"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_06.jpg",
        "title": "Туроператор «Квинта тур»",
        "name": "Большое путешествие по Узбекистану",
        "duration": "8 дней / 7 ночей",
        "price": "от 48 000 рублей",
        "url": "/tours?tour=1#tour6"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_07.jpg",
        "title": "Туроператор ICS Travel Group",
        "name": "Навруз — Восточный Новый год",
        "duration": "7 дней / 6 ночей",
        "price": "от 98 976 рублей",
        "url": "/tours?tour=1#tour7"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_07.jpg",
        "title": "Туроператор ICS Travel Group",
        "name": "8 Марта. За милых дам ",
        "duration": "5 дней / 4 ночи",
        "price": "от 27 795 рублей",
        "url": "/tours?tour=0#tour7"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_08.png",
        "title": "Туристическая компания «Ванд Интернэшнл тур»",
        "name": "Весенний тур в Узбекистан",
        "duration": "3 дня / 3 ночи",
        "price": "от 20 980 рублей",
        "url": "/tours?tour=0#tour8"
      },
      {
        "logo": "/uploads/workshops/projects/uzbekistan2020/img/to/logo_08.png",
        "title": "Туристическая компания «Ванд Интернэшнл тур»",
        "name": "Аральское море и оазис древних городов",
        "duration": "11 дней / 10 ночей",
        "price": "от 79 064 рублей",
        "url": "/tours?tour=1#tour8"
      }
    ];

  function generateSPO() {
    var $teaser = $('.js-spo-teaser'),
      n = Math.floor(Math.random() * spo.length),
      home = $('.js-text').data('url') !== '/' ? $('.js-text').data('url') : '';

    $('.js-text', $teaser)
      .append(
        $('<img/>').attr('src', spo[n].logo)
      )
      .append(
        $('<p/>').addClass('spo__name').text(spo[n].title)
      )
      .append(
        $('<p/>').addClass('spo__title').text(spo[n].name)
      )
      .append(
        $('<p/>').addClass('spo__duration').text(spo[n].duration)
      )
      .append(
        $('<p/>').addClass('spo__price').text(spo[n].price)
      )
      .append(
        $('<a />').addClass('spo__btn').attr({'href': home + spo[n].url}).html('Подробнее')
      );
  }

  generateSPO();


});
